module.exports = "/assets/data/ad63a630505b63973e25908ce9c0090f-SW1W.data.json";